import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowUpLeft: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M7 17V7h10' }],
    ['path', { d: 'M17 17 7 7' }],
  ],
];

export default ArrowUpLeft;
